// ============================================================================
// Woodcutting Requirements - Requirements for woodcutting actions
// ============================================================================
import { createEquippedItemRequirement, createHasPawnSelectedRequirement, } from '../actions/requirements.js';
/**
 * Get the requirements for chopping a tree.
 * Trees require a pawn and an axe (any tier).
 */
export const getAxeRequirements = () => {
    return [
        createHasPawnSelectedRequirement(),
        createEquippedItemRequirement({ itemCategory: 'axe' }),
    ];
};
//# sourceMappingURL=requirements.js.map